import Conf from "../Conf";
import axios from "axios";
export const goLogin = (callback) => {
  if (callback && callback !== "") {
    var cookie = {
      callback: callback,
    };
    localStorage.setItem(Conf.cookieName, JSON.stringify(cookie));
  }
  window.location.href = Conf.frontendURL + "login";
};

export const makeid = (length) => {
  return new Promise((resolve) => {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZ123456789abcdefghijklmnopqrstuvwxyz+-*:.";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    resolve(result);
  });
};

export const getPermission = (token) => {
  return new Promise((resolve) => {
    axios
      .get(Conf.authURL + "me", {
        headers: { Authorization: token, "X-Requested-With": "profile" },
      })
      .then((res) => {
        if (res.data.profile && res.data.profile.usn) {
          axios
            .get(Conf.backendURL + "user", {
              headers: { Authorization: res.data.profile.usn },
            })
            .then((res2) => {
              if (res2.data === false) resolve(false);
              else resolve({ profile: res.data.profile });
            });
        } else resolve(false);
      });
  });
};

export const getStampTime = (d) => {
  return new Promise((resolve) => {
    var dt = new Date();
    if (d) dt = new Date(d);
    var day = dt.getDate();
    var m = dt.getMonth() + 1;
    var y = dt.getFullYear();

    var h = ("0" + dt.getHours()).slice(-2);
    var mi = ("0" + dt.getMinutes()).slice(-2);
    var s = ("0" + dt.getSeconds()).slice(-2);
    var ms = ("00" + dt.getMilliseconds()).slice(-3);
    var host_time = h + ":" + mi + ":" + s + "." + ms;
    var slice_time = {
      hour: h,
      minute: mi,
      seconds: s,
      millisecond: ms,
    };
    var iso_date = y + "-" + ("0" + m).slice(-2) + "-" + ("0" + day).slice(-2);

    resolve({ iso_date, host_time, slice_time });
  });
};
